import React, {useState, Fragment} from "react";
import { Link } from "react-router-dom";
//import { Home } from "../pages/home";
//import { About } from "../pages/about";
import "../styles/navbar.css";

function menuFunction() {
    window.onload = function(){ 
    let btn = document.getElementById("toggle");
    let ul = document.querySelector("ul");
    btn.onclick = function () {
    ul.classList.toggle("show");
    }
    console.log(1);
};
}

export default function Menu() {
      return (
        <nav>
        <Link to={'/'} className="title"></Link><img id="logo" src={require('../files/logo.jpeg')} />
        <Link to={'/'} className="title">Public Interest Ad Archive</Link>
        <ul>
            <li><Link to={'/'}>Home</Link></li>
            <li><Link to={'/about'}>About</Link></li>
            <li><Link to={`/search`}>Search</Link></li>
            <li><Link to={`/batches`}>View data</Link></li>
            <li><Link to={`/analytics`}>Analytics</Link></li>
            <li><Link to={`/contact`}>Contact us</Link></li>
        </ul>
        <input type="checkbox" id="toggle" onClick={() => {document.querySelector("ul").classList.toggle("show");}} />
        <label className="navLabel" htmlFor="toggle"/>
    </nav>  
    );
        
}
